import { createContext } from "react";

const context = createContext();
context.displayName = "audience";

export default context;
